(function() {
    'use strict';

    var StoricoDinamicoCtrl = function(
        $q,
        $scope,
        $state,
        $stateParams,
        $cacheFactory,
        CONSTANTS,
        messaggiFctr,
        storicoInvioCredenzialiService,
        invioCredenzialiService,
        $uibModalInstance,
        uiGridConstants
    ) {
        this.listaRichieste = [];
        this.loading = 0;
        this.invioCredenzialiService = invioCredenzialiService;

        this.init = () => {
            this.loading = (this.loading > 0) ? this.loading + 1 : 1;

            if ('StoricoUtenteSymantec' == this.invioCredenzialiService.modalita) {
                this.titolo = 'Storico Utente Symantec';
                caricaStoricoUtenteSymantec();
            } else if ('StoricoGlobaleSymantec' == this.invioCredenzialiService.modalita) {
                this.titolo = 'Storico Utente Symantec & Dispositivi utente';
                caricaStoricoGlobaleSymantec();
            } else if ('StoricoSmsOtp' == this.invioCredenzialiService.modalita) {
                this.titolo = 'Storico Invii Otp Sms';
                caricaStoricoSmsOtp();
            } else {
                this.titolo = 'Invio credenziali - Storico richieste';
                caricaStoricoCredenziali();
            }
        };

        let caricaStoricoCredenziali = () => {
            storicoInvioCredenzialiService
                .storicoCredenziali(invioCredenzialiService.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        this.listaRichieste = [];
                        let risultati = res.data.result; 
                        risultati.forEach((richiesta) => {
                            richiesta = this.formattaRecapito(richiesta);
                            this.listaRichieste.push(richiesta);
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        let caricaStoricoUtenteSymantec = () => {
            storicoInvioCredenzialiService
                .storicoUtenteSymantec(invioCredenzialiService.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        this.listaRichieste = [];
                        let risultati = res.data.result; 
                        risultati.forEach((richiesta) => {
                            this.listaRichieste.push(richiesta);
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        let caricaStoricoGlobaleSymantec = () => {
            storicoInvioCredenzialiService
                .storicoGlobaleSymantec(invioCredenzialiService.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        this.listaRichieste = [];
                        let risultati = res.data.result; 
                        risultati.forEach((richiesta) => {
                            this.listaRichieste.push(richiesta);
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        let caricaStoricoSmsOtp = () => {
            storicoInvioCredenzialiService
                .storicoSmsOtp(invioCredenzialiService.datiMito.codiceUtente)
                .then(
                    (res) => {
                        if (messaggiFctr.processaResponse(res) || !res.data.result) {
                            return;
                        }
                        this.listaRichieste = [];
                        let risultati = res.data.result; 
                        risultati.forEach((richiesta) => {
                            this.listaRichieste.push(richiesta);
                        });
                    },
                    (error) => {
                        messaggiFctr.processaResponse(error);
                    }
                )
                .finally(() => {
                    this.loading--;
                });
        };

        let columns = [];
        if (['StoricoUtenteSymantec', 'StoricoGlobaleSymantec'].includes(this.invioCredenzialiService.modalita)) {
            columns = [
                { field: 'idCredenziale', name: 'Credenziale' },
                { field: 'canale', name: 'Canale' },
                { field: 'dataOperazione', name: 'Data Operazione', cellFilter: "date:'dd/MM/yyyy HH:mm'", sort: { direction: uiGridConstants.DESC } },
                { field: 'friendlyName', name: 'Friendly Name' },
                { field: 'operatore', name: 'Operatore' },
                { field: 'tipoCredenziale', name: 'Tipo Credenziale' },
                { field: 'tipoOperazione', name: 'Tipo Operazione' },
                { field: 'stato', name: 'Stato' },
                { field: 'causale', name: 'Causale' },
                { field: 'note', name: 'Note', width: '20%' },
            ];
        } else if (this.invioCredenzialiService.modalita == 'StoricoSmsOtp') {
            columns = [
                { field: 'numeroTelefono', name: 'Numero Telefono' },
                { field: 'dataInvio', name: 'Data Invio', cellFilter: "date:'dd/MM/yyyy HH:mm:ss'" },
                { field: 'dataArrivo', name: 'Data Arrivo', cellFilter: "date:'dd/MM/yyyy HH:mm:ss'" },
                { field: 'esito', name: 'Esito' },
            ];
        } else {
            columns = [
                { field: 'tipologiaDato', name: 'Credenziale' },                
                { field: 'canaleInvio', name: 'Canale' },
                { field: 'recapito', name: 'Recapito' },
                { field: 'operatore', name: 'Utente' },
                { field: 'dataInvio', name: 'Data e ora', cellFilter: "date:'dd/MM/yyyy HH:mm'", sort: { direction: uiGridConstants.DESC } }
            ];
        }

        this.gridStorico = {
            enableSorting: true,
            enableHiding: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: 0,
            enableHorizontalScrollbar: 0,
            paginationPageSize: 9,
            columnDefs: columns,
            data: 'storicoCtrl.listaRichieste'
        };

        this.formattaRecapito = (richiestaCredenziali) => {
            richiestaCredenziali.recapito = richiestaCredenziali.canaleInvio === 'SMS' ? `+${richiestaCredenziali.recapito}` : richiestaCredenziali.recapito;
            return richiestaCredenziali;
        };

        this.close = () => {
            $uibModalInstance.dismiss();
        };

        this.init();
    };

    StoricoDinamicoCtrl.$inject = [
        '$q',
        '$scope',
        '$state',
        '$stateParams',
        '$cacheFactory',
        'Mitom_CONSTANTS',
        'MitomMessaggiFctr',
        'MitomStoricoDinamicoService',
        'MitomInvioCredenzialiService',
        '$uibModalInstance',
        'uiGridConstants'
    ];

    angular
        .module('cbl.mitomanager.wa')
        .controller('MitomStoricoDinamicoController', StoricoDinamicoCtrl);
})();